/** フライト開始地点情報種別定義 */
export const HomeElevationType = {
  /** 情報なし */
  NOT_APPLICABLE: 0,
  /** 経度緯度 */
  LATLNG: 1,
  /** 高度 */
  ALTITUDE: 2,
  /** ファイル名 */
  FILE_NAME: 3
} as const

/** フライト開始地点情報種別 */
export type HomeElevationType = (typeof HomeElevationType)[keyof typeof HomeElevationType]

/** フライトプロジェクトデータ */
export interface FlightProjectData {
  /** プロジェクトID */
  projectId: number | undefined
  /** プロジェクト一覧 */
  projectList: Project[]
  /** フライト高度 */
  flightAltitude: number | undefined
  /** フライト開始地点情報種別 */
  homeElevationType: HomeElevationType
  /** フライト開始地点緯度経度 */
  homeElevationLatlng: {
    latitude: number | undefined
    longitude: number | undefined
  }
  /** フライト開始地点高度 */
  homeElevationValue: number | undefined
  /** フライト開始地点撮影ファイル名 */
  homeElevationImgFileName: string
}

/** プロジェクト情報 */
export interface Project {
  id: number
  name: string
}

/** アップロード状態定義 */
export const UploadStatus = {
  /** アップロード開始待ち */
  WAIT: 'Wait',
  /** アップロード処理待ち */
  WAITING_UPLOAD: 'WaitingUpload',
  /** アップロード中 */
  UPLOADING: 'Uploading',
  /** アップロード完了 */
  COMPLETE: 'Complete',
  /** エラー */
  ERROR: 'Error'
} as const

/** アップロード状態 */
export type UploadStatus = (typeof UploadStatus)[keyof typeof UploadStatus]

/** アップロードファイルデータ */
export interface UploadFileData {
  /** 内部管理キー（中断等に使用） */
  key: string
  /** ファイル名 */
  fileName: string
  /** ファイル */
  file: File
  /** アップロード状態 */
  status: UploadStatus
  /** アップロード進捗 */
  progress: number
  /** 完了日時 */
  completedDateTime?: Date
  /** プロジェクトID */
  projectId?: number
}

/** アップロードファイルテーブル行データ */
export interface UploadTableRow {
  /** プロジェクト名 */
  projectName: string
  /** ファイル名 */
  fileName: string
  /** 状態 */
  statusLabel: string
  /** アップロード状態 */
  status: UploadStatus
  /** 完了日時 */
  completeDateTime: string
}
